<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>代采报表-先货后款</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form ref="form" :model="form" label-width="85px">
                <el-row :gutter="10">
                  <el-col>
                    <el-form-item label="输入搜索：">
                      <el-col :span="3">
                        <el-select
                          v-if="pgOption"
                          v-model="form.pgid"
                          filterable
                          placeholder="代采组"
                        >
                          <el-option
                            v-for="item in pgOption"
                            :key="item.key"
                            :label="item.label"
                            :value="item.key"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="3">
                        <el-input
                          v-model="form.supply_name"
                          placeholder="商家名称"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="3">
                        <el-select
                          v-model="form.order_owner"
                          filterable="filterable"
                          placeholder="订单负责人"
                        >
                          <el-option label="">全部</el-option>
                          <el-option
                            v-for="item in owner_option"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="2">
                        <el-input
                          v-model="form.woid"
                          placeholder="代采单"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="3">
                        <el-input
                          v-model="form.goods_kh"
                          placeholder="款号"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="3">
                        <el-input
                          v-model="form.goods_no"
                          placeholder="货号"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="3">
                        <el-select v-model="form.source" placeholder="开单来源">
                          <el-option
                            v-for="item in sources"
                            :key="item.key"
                            :label="item.label"
                            :value="item.key"
                          ></el-option>
                        </el-select>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="7">
                    <el-form-item label="生成时间">
                      <el-date-picker
                        v-model="form.create_time"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="2">
                    <el-button type="primary" @click="search">查询</el-button>
                  </el-col>
                  <el-form-item>
                    <el-button type="success" @click="outputAll">
                      导出所有数据</el-button
                    >
                  </el-form-item>
                </el-row>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div v-if="resData" style="margin-bottom: 40px">
          <div
            style="
              background: #f3f3f3;
              height: 50px;
              line-height: 30px;
              padding: 0 25px;
              display: flex;
              align-items: center;
              position: relative;
            "
          >
            x
            <div>汇总（全部）</div>
            <div style="position: absolute; right: 0">
              <el-button size="mini" type="success" @click="output">
                导出查询数据</el-button
              >
            </div>
          </div>
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            :data="resData.supply"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column prop="supply_id" label="商家ID" align="center">
            </el-table-column>
            <el-table-column prop="supply_name" label="商家" align="center">
            </el-table-column>
            <el-table-column
              prop="reject_data"
              label="实际开单"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.kd_num }} / {{ scope.row.kd_amount }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="reject_out"
              label="已回货"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.real_stock_in_num }} /
                  {{ scope.row.real_stock_in_amount }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="代采欠货"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.cg_owe_num }} /
                  {{ scope.row.cg_owe_amount }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="supply_settle_status"
              label="退换货欠货"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.rj_owe_num }} /
                  {{ scope.row.rj_owe_amount }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              label="转抵扣"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.all_ded_num }} /
                  {{ scope.row.all_ded_amount }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              label="已退款"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.all_refund_num }} /
                  {{ scope.row.all_refund_amount }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              label="结束代采"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.cp_num }} / {{ scope.row.cp_amount }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="reject_out"
              label="账单已结算"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.bill_num }} / {{ scope.row.bill_amount }}</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="resData" style="margin-bottom: 0">
          <div
            style="
              background: #f3f3f3;
              height: 50px;
              line-height: 30px;
              padding: 0 25px;
              display: flex;
              align-items: center;
            "
          >
            <div>商家订单明细数据</div>
          </div>
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            :cell-class-name="addBackground"
            :row-class-name="tableRowClassName"
          >
            <el-table-column prop="woid" label="代采订单" align="center">
            </el-table-column>
            <el-table-column prop="create_time" label="时间" align="center">
            </el-table-column>
            <el-table-column prop="pgname" label="代采组" align="center">
            </el-table-column>
            <el-table-column
              prop="owner_admin_name"
              label="订单负责人"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="实际开单"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.kd_num }} / {{ scope.row.kd_amount }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="reject_out"
              label="已回货"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.real_stock_in_num }} /
                  {{ scope.row.real_stock_in_amount }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="代采欠货"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.cg_owe_num }} /
                  {{ scope.row.cg_owe_amount }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="supply_settle_status"
              label="退换货欠货"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.rj_owe_num }} /
                  {{ scope.row.rj_owe_amount }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              label="转抵扣"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.all_ded_num }} /
                  {{ scope.row.all_ded_amount }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              label="已退款"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.all_refund_num }} /
                  {{ scope.row.all_refund_amount }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              label="结束代采"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.cp_num }} / {{ scope.row.cp_amount }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="reject_out"
              label="账单已结算"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.bill_num }} / {{ scope.row.bill_amount }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="reject_out"
              label="操作"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(scope.row)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <!--<el-col style="text-align: right;padding: 25px;" v-if="resData">-->
          <!--<el-pagination @current-change="handleCurrentChange" :current-page.sync="curPage" background-->
          <!--layout="total, prev, pager, next, jumper " :total="Number(resData.count)"-->
          <!--:page-size="10">-->
          <!--</el-pagination>-->
          <!--</el-col>-->
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: null,
      form: {
        supply_id: "",
        source: -1,
      },
      loading: false,
      url: "/erp/SupplySettle/supplySettleReport",
      status: 100,
      curPage: 1,
      pgOption: [],
      owner_option: [],
      supplyOption: [],
      tableLoading: false,
      filterFold: false,
      multipleSelection: [],
      sources: [
        {
          key: -1,
          label: "全部",
        },
        {
          key: 1,
          label: "一手",
        },
        {
          key: 2,
          label: "爆版",
        },
      ],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    outputAll() {
      this.form.is_excel = 1;
      this.form.is_all = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_all = 0;
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },

    fetchData() {
      this.loading = true;
      this.$http.post("/erp/SupplySettle/getPurchaseGroup").then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          return this.$message.error(res.data.msg);
        }
        this.pgOption = res.data.data.pgOption;
        this.owner_option = res.data.data.owner_option;
      });
    },
    pgOptionChange(val) {
      if (!val) {
        return false;
      }
      this.loading = true;
      this.$http
        .post("/erp/SupplySettle/getPgSupply", { pgid: this.form.pgid })
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            return this.$message.error(res.data.msg);
          }
          this.form.supply_id = "";
          this.supplyOption = res.data.data.supplyOption;
        });
    },
    supplyOptionChange(val) {
      this.form.supply_id = val;
    },
    /* 列颜色 */
    addBackground({ row, column, columnIndex }) {
      if (
        (columnIndex === 5 && row.cg_owe_num > 0) ||
        (columnIndex === 6 && row.rj_owe_num > 0)
      ) {
        return "warning-cell";
      }
    },
    /* 行颜色处理 */
    tableRowClassName({ row, rowIndex }) {
      if (row.diff_num !== 0) {
        // notice-row
        return "warning-row";
      }
      return "";
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleClick(row) {
      this.$router.push(`/home/report/SupplyReportDetail/${row.woid}`);
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          (this.status = this.filteredForm.status), (this.curPage = 1);
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/supplybill/SupplyXhhkReport.vue